<template>
    <v-container fluid class="d-flex align-center justify-center fill-height">
      <v-row align="center" justify="center" no-gutters>
        <v-col cols="12" sm="8" md="4">
          <v-card class="pa-5" elevation="3">
            <v-card-title class="text-center">{{ $t('message.resetPassword') }}</v-card-title>
            <v-card-text>
              <v-form>
                <v-text-field
                  :label="$t('message.newPassword')"
                  prepend-icon="mdi-lock-check"
                  v-model="newPassword_1"
                  type="password"
                  :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                  :label="$t('message.newPassword')"
                  prepend-icon="mdi-lock-check"
                  v-model="newPassword_2"
                  type="password"
                  :rules="[rules.required, confirmPasswordRule]"
                ></v-text-field>
                <v-btn color="primary" class="mt-4" block @click="resetPassword">
                  {{ $t('message.resetPassword') }}
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
  
      <!-- Snackbar for success message -->
      <v-snackbar
          v-model="snackbarSuccess"
          color="success"
          top
          multi-line
          timeout="3000"
      >
        {{ successMessage }}
        <template v-slot:actions>
          <v-btn color="white" text @click="snackbarSuccess = false">Close</v-btn>
        </template>
      </v-snackbar>

      <!-- Snackbar for error message -->
      <v-snackbar
          v-model="snackbarError"
          color="error"
          top
          multi-line
          timeout="3000"
      >
        {{ errorMessage }}
        <template v-slot:actions>
          <v-btn color="white" text @click="snackbarError = false">Close</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </template>
  
  <script>
  import axios from 'axios';
  import {mapActions} from 'vuex';
  
  export default {
    data() {
      return {
        // oldPassword: '',
        newPassword_1: '',
        newPassword_2: '',
        snackbarSuccess: false,
        snackbarError: false,
        successMessage: '', // Store success message
        errorMessage: '', // Store error message
        rules: {
          required: value => !!value || 'Required.',
          email: value => /.+@.+\..+/.test(value) || 'E-mail must be valid.',
        },
      };
    },
    mounted() {},
    computed: {
      confirmPasswordRule() {
        return value => value === this.newPassword_1 || 'Passwords must match.';
      },
    },
    methods: {
      ...mapActions(['logout']),
      getValidateCode() {
        let params = this.$route.query;
        return params.validateCode;
        // catch this user's validate code and verify with validate code from url
        // if same, then allow to reset pwd, otherwise pop up a error msg to remind user validate code is wrong.
        
        // about reset pwd, if user passed the validate code verification, just type in the new pwd twice will be ok.
      },
      async resetPassword() {
        let v_code = this.getValidateCode();
        if(v_code === "" || v_code === null) {
          console.log('Illeagal v_code.')
        }else {
          if(this.newPassword_1 === this.newPassword_2) {
            console.log('pwd verification passed.')
            let data = JSON.stringify({
              "code": v_code,
              'new_password': this.newPassword_1
            });
            let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: '/api/user/ResetPasswordView/',
              data: data
            };
            try {
              await axios.request(config).then((res) => {
                console.log(JSON.stringify(res.data));
                this.successMessage = 'Password Reset Successful!';
                this.snackbarSuccess = true;
                setTimeout(() => {
                  this.$router.push('/login')
                }, 3000);
            })
            } catch(err)   {
              console.log(err.response.data);
              this.errorMessage = err.response?.data?.msg || 'Password Reset Failed. Please try again.';
              this.snackbarError = true;
            }
          }else {
            console.log('new pwd1 should same as new pwd2.')
          }
        }



        // if(this.checkAuth()) {
            
        // }else {
        //     console.log('Validate code not match, not allowed to reset pwd.')
        // }
      },
    },
  };
  </script>
  
  <style scoped>
  .fill-height {
    min-height: 100vh;
  }
  </style>